import React, { useEffect, useState } from "react";
import axios from "../axios";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Login.css";
import { useDispatch } from "react-redux";
import { useSearchParams } from 'react-router-dom'
export default function Login() {
  const [searchParams, setSearchParams] = useSearchParams()
  const accessTokenQuery =  searchParams.get('accessToken')
  const isTrial =  searchParams.get('isTrial')
  const accessType = searchParams.get("accessType")
  const navigate = useNavigate();
  
  

  useEffect(() => {
    
    if(accessTokenQuery){
      localStorage.setItem("accessToken", accessTokenQuery);
      if (isTrial  == true || accessType== 'trial' || accessType== 'Trial') {  
        navigate("/trial-user");
        localStorage.setItem("isTrial", true);  
        
      } else if(accessType == "Subscribed" || accessType == "subscribed") {
        navigate("/subscribed-user");
        localStorage.setItem("isTrial", false);
      }
      dispatch({ type: "login" });
      
    }    
  }, [])

  useEffect(() => {
    setTimeout(function () {
      if (localStorage.getItem("isTrial") == "true") {
        navigate("/trial-user");
      } else if (localStorage.getItem("isTrial") == "false") {
        navigate("/subscribed-user");
      }
    }, 0);
  }, []);

  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const onLogin = () => {
    let formData = new FormData();
    formData.append("loginId", email);
    formData.append("password", password);
    LoginApi(formData);
  };
  const LoginApi = (data) => {
    axios
      .post("/userLogin", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("Response: ", response);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("userId", email.toLowerCase());
        localStorage.setItem("userName", response.data.firstname);
        if (response.data.accessType==='trial'|| response.data.accessType==='Trial') {
          navigate("/trial-user");
          localStorage.setItem("isTrial", true);
        } else if (response.data.accessType == "Subscribed" || response.data.accessType == "subscribed") {
          navigate("/subscribed-user");
          localStorage.setItem("isTrial", false);
        }
        dispatch({ type: "login" });
        window.location.reload();
      })
      .catch((error) => {
        console.log("Error:", error.response.data.message);
        setErrorMessage(error.response.data.message);
      });
  };
  const onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
      onLogin();
    }
  };

  return localStorage.getItem("isTrial") != ("true" || "false") ? (
    <div className="Login">
      <span className="Login-Head-text">Login to Swaasa subscription</span>
      <div className="Login-box">
        <span className="Login-box-infoText">
          Use Existing Swaasa credentials
        </span>
        <div className="Login-box-form">
          <div className="Login-box-form-input">
            <span className="Login-box-form-input-text">Email</span>
            <input
              className="Login-box-form-input-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Type Email"
            ></input>
            <span className="Login-box-form-input-text">Password</span>
            <div>
              <input
                className="Login-box-form-input-input"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => onKeyDownHandler(e)}
                placeholder="--------"
              ></input>
              {showPassword ? (
                <i
                  className="far fa-eye"
                  id="togglePassword"
                  style={{ marginLeft: "-30px", cursor: "pointer" }}
                  onClick={toggleShowPassword}
                ></i>
              ) : (
                <i
                   className="far fa-eye-slash"
                  id="togglePassword"
                  style={{ marginLeft: "-30px", cursor: "pointer" }}
                  onClick={toggleShowPassword}
                ></i>
              )}
            </div>
          </div>
          <button className="Login-box-form-login-btn" onClick={onLogin}>
            Login
          </button>
        </div>
      </div>
      <span
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          color: "red",
          fontSize: "18px",
        }}
      >
        {errorMessage}
      </span>
    </div>
  ) : (
    <div></div>
  );
}
